export const uk = {
    'adjustments-rate': 'Ставки показаны без учёта применяемых к ним корректировок'
};
